var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"home_icon",staticClass:"home_icon"},[_c('div',{staticClass:"icon"},[_c('svg-icon',{attrs:{"icon-class":_vm.iconSrc}})],1),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.iconText))])])}
var staticRenderFns = []

export { render, staticRenderFns }